<template>
    <div class="help column is-6">
        <div class="room-help" v-if="data">
            <div class="field pull-left">
              <input type="text" v-model="data.content" placeholder="beskrivning">
            </div>
            <div class="field">
                <label class="label pull-left">Fil</label>
                <div v-if="data.media">
                    {{data.media}}
                    <a class="button" @click="removeMedia"><i class="fa fa-remove"></i></a>
                </div>
                <input v-else type="file" @change="updatemedia" placeholder="Fil">
            </div>
            <div class="field">
                <button class="button is-default pull-right" @click="save"><i class="fa fa-save"></i>&nbsp; Spara fil</button>
            </div>

        </div>
    </div>

</template>
<style>
  .editr{
    background-color: #fff;
    color: #000;
  }
</style>
<script>
// const _ = require('lodash')
import RoomData from '@/mixins/RoomContent'

export default {
  name: 'RoomFile',
  mixins: [RoomData],

  data () {
    return {
      data: null,
      mediabutton: null,
      startdata: {
        content: null,
        media: null,
        group: 'files',
        age_group_id: null,
        key: 'fil',
        type: 'file'
      }
    }
  },
  props: ['orgdata'],
  components: {},
  computed: {
  },
  methods: {
  },
  mounted () {
    this.reset()
  }
}
</script>
